<template>
  <div id="ads">
    <header-top ></header-top>
    <div class="header-title">{{headerText}}</div>
    <div class="ads-list">
      

      <div class="list-table">
        <div class="btn-group flex-between handle">
        <!-- 顶部左侧 -->
        <div class="flex">
          <el-button class="create-btn" type="primary" @click="createAds"
            >创建广告</el-button
          >
          <el-select
            class="handle-select type-select"
            v-model="query.statusType"
            filterable
            reserve-keyword
            clearable
            placeholder="发布状态"
            @change="getAds"
          >
            <el-option
              v-for="(item, key) in adsStatusDic"
              :key="key"
              :value="key"
              :label="item"
              style="text-align: center"
            />
          </el-select>
          <!-- <el-select
            class="handle-select type-select"
            v-model="query.TradeType"
            filterable
            reserve-keyword
            clearable
            placeholder="交易类型"
            @change="getAds"
          >
            <el-option
              v-for="(item, key) in adsTradeTypeDic"
              :key="key"
              :value="key"
              :label="item"
              style="text-align: center"
            />
          </el-select> -->

          <span class="line"></span>
          <el-select
            v-model="query.TimeCondition"
            placeholder="创建时间"
            class="handle-select custom"
          >
            <el-option label="创建时间" value="CreationTime"></el-option>
            <el-option label="启用时间" value="startTime"></el-option>
          </el-select>
          <el-date-picker
            v-model="time"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            class="date-picker filter-date"
            type="daterange"
            align="left"
            unlink-panels
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getAds"
          />
        </div>
        <!-- 顶部右侧 -->
        <div class="flex" style="padding-right: 7px">
          <div class="search">
            <el-input
              v-model="query.Filter"
              class="search-name"
              reserve-keyword
              clearable
              placeholder="名称..."
              @keyup.enter.native="keyup_submit"
            >
              <i
                class="el-icon-search el-input__icon input__suffix"
                slot="suffix"
                @click="getAds"
              ></i>
            </el-input>
          </div>
        </div>
      </div>
        <el-table
          :data="adsList"
          class="table-top-border"
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50" />
          <el-table-column
            label-class-name="tab-tit"
            show-overflow-tooltip
            label="广告名称"
            min-width="150"
            align="left"
          >
            <template slot-scope="scope">
              <!-- <div class="name">
                <div> -->
                  <span>
                    {{ scope.row.name | valLength(15) }}
                  </span>

                  <!-- <br />
                  <span class="quick-view" @click="quickView(scope.row)"
                    >快捷查看</span
                  >
                </div>
              </div> -->
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="tab-tit"
            label="启用时间"
            min-width="200"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.startTime | nullValue }}
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="tab-tit"
            label="截止时间"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.endTime | nullValue }}
            </template>
          </el-table-column>

          <el-table-column
            label-class-name="tab-tit"
            label="展位总数"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.placeTotalCount | nullValue }}
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="tab-tit"
            label="正常展位数"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.normalPlaceCount | nullValue }}
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="tab-tit"
            label="发布状态"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              <div class="table-icon">
                <svg-icon
                  class="svg"
                  v-if="scope.row.statusType == '未发布'"
                  icon-class="status-wait"
                />
                <svg-icon
                  class="svg"
                  v-else-if="scope.row.statusType == '已下架'||scope.row.statusType == '已过期'"
                  icon-class="status-close"
                />
                <svg-icon
                  class="svg"
                  v-else-if="scope.row.statusType == '已发布'"
                  icon-class="success"
                />
                {{ scope.row.statusType | nullValue }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="manageInformation(scope.row.id)"
                >详情</el-button
              >
              <el-button
                type="text"
                @click="changeStatus(scope.row)"
                v-if="scope.row.statusType != '已发布'"
                >发布</el-button
              >
              <el-button type="text" @click="changeStatus(scope.row)" v-else
                >取消发布</el-button
              >
              <el-dropdown
                @command="handleCommand"
                trigger="click"
                placement="bottom"
              >
                <span class="el-dropdown-link">更多</span>
                <el-dropdown-menu slot="dropdown" class="opertion-dropdown">
                  <el-dropdown-item
                    :command="beforeHandleCommand(scope.row, 'delete')"
                  >
                    <span>删除</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="@/assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div class="empty-box" v-if="!isLoading && !adsList.length">
              列表为空
            </div>
          </template>
        </el-table>
        <el-pagination
          :current-page.sync="currentPage"
          :page-size="query.MaxResultCount"
          :page-sizes="[10, 20, 30, 50, 100]"
          :total="totalCount"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <el-drawer
      :title="adsInfo.name"
      :with-header="false"
      :visible.sync="isDrawerShow"
      direction="rtl"
    >
      <div class="drawer-title">
        {{ adsInfo.name }}
        <span @click="isDrawerShow = false">
          <svg-icon icon-class="close-ico" />
        </span>
      </div>
      <el-form label-position="left" label-width="6rem">
        <div class="basic-item">
          <div class="basic-item-title basic-title-edit">
            基本信息
            <div
              class="basic-edit"
              @click="manageInformation(adsInfo.id, '修改')"
            >
              修改
            </div>
          </div>
          <div class="basic-item-main">
            <el-form :model="adsInfo" ref="adsInfo" label-width="6rem">
              <div class="adsInfo">
               
                <el-form-item label="广告名称">
                  {{ adsInfo.name | nullValue }}
                </el-form-item>
                <el-form-item label="广告类型">
                  {{ adsInfo.type | nullValue }}
                </el-form-item>
                <el-form-item label="广告排序">
                  {{ adsInfo.sort | nullValue }}
                </el-form-item>

                <el-form-item label="广告开始时间">
                  {{ adsInfo.startTime | nullValue }}
                </el-form-item>
                <el-form-item label="广告下架时间">
                  {{ adsInfo.endTime | nullValue }}
                </el-form-item>
                <el-form-item label="广告跳转">
                  {{ adsInfo.jumpUrl | nullValue }}
                </el-form-item>
                <el-form-item label="广告介绍" class="auto-height">
                  {{ adsInfo.more | nullValue }}
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        
      </el-form>
    </el-drawer>

  </div>
</template>
<script>
import { getAds, deleteAds, updateAdsStatus, getAdsInfo } from "@/http/api/ads";
import headerTop from "@/components/HeaderTop";
export default {
  components: {
    headerTop,
  },
  data() {
    return {
      headerText: "广告管理",
      adsList: [],
      placeList: [],
      isDrawerShow: false,
      query: {
        Filter: "",
        Condition: "",
        Scope: "",
        Sorting: "creationTime desc",
        statusType: null,
        TimeCondition: "",
        StartTime: null,
        EndTime: null,
        MaxResultCount: 20,
        SkipCount: 0,
      },
      adsStatusDic: {
        UnShelved: "已下架",
        Published: "已发布",
        UnPublish: "已撤销",
        Expired: "已过期",
      },
      adsInfo: {},
      isLoading: true,
      key: "",
      time: "",
      currentPage: 1,
      totalCount: 0,
      popover: false,
      user: this.$store.getters.user,
      permissions: this.$store.getters.permissions,
      btnDisabled: true,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.getAds();
    document.body.addEventListener(
      "click",
      () => {
        this.popover = false;
      },
      false
    );
  },
  methods: {
    quickView(row) {
      getAdsInfo(row.id).then((res) => {
        this.adsInfo = res.result
        this.isDrawerShow = true;
      });
    },
    
    // 管理资讯
    manageInformation(id, v) {
      //   if (this.permissions["RocketIdentity.Users.Update"]) {
      this.$router.push({
        path: `ads-details/${id}`,
      });
      //   } else {
      //     this.$message.warning({
      //       message: `您暂无${v}资讯权限`,
      //       showClose: true,
      //     });
      //   }
    },
    changeStatus(item) {
      let statusType = "";
      let title = "";
      if (item.statusType == "已发布") {
        statusType = "UnPublish";
        title = "关闭";
      } else {
        statusType = "Published";
        title = "发布";
      }
      this.$confirm(`你确定要${title}吗?`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateAdsStatus(item.id, statusType).then((res) => {
            if (res.code == 10200) {
              this.$message.success({
                message: res.message,
                showClose: true,
              });
              this.getAds();
            }
          });
        })
        .catch(() => {
        });
    },
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleCommand(command) {
      if (command.command == "delete") {
        this.delete(command.row);
      }
    },
    delete(item) {
      this.$confirm("你确定要删除吗?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAds(item.id).then((res) => {
            if (res.code == 10200) {
              this.$message.success({
                message: res.message,
                showClose: true,
              });
              this.getAds();
            }
          });
        })
        .catch(() => {
        });
    },
    createAds() {
      this.$router.push({
        path: `ads-create`,
      });
    },
  

    pageSizeChange(val) {
      this.query.MaxResultCount = val;
      this.currentPage = 1;
      this.query.SkipCount = 0;
      this.getAds();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAds();
    },

    keyup_submit() {
      var evt = window.event || e;
      if (evt.keyCode == 13) {
        // 回车事件
        this.getAds();
      }
    },
    getAds() {
      this.isLoading = true;
      if (this.time != "" && this.time != null) {
        this.query.StartTime = this.time[0];
        this.query.EndTime = this.time[1];
      } else {
        this.query.TimeCondition = "";
        this.query.StartTime = null;
        this.query.EndTime = null;
      }
      if (this.query.statusType == "") {
        delete this.query.statusType;
      }

      this.query.SkipCount = (this.currentPage - 1) * this.query.MaxResultCount;
      getAds(this.query)
        .then((res) => {
          var data = res.result;

          this.totalCount = data.totalCount;
          this.adsList = data.items;
          this.isLoading = false;
        })
        .catch((err) => {});
    },

    handleSelectionChange(val) {
      var data = [];
      for (var a = 0; a < val.length; a++) {
        data.push(val[a].id);
      }
      if (data.length > 0) {
        this.btnDisabled = false;
      } else {
        this.btnDisabled = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/mixin.scss";
#ads {
  width: 100%;
  min-width: 1110px;
  .filter-date {
    border-left-color: transparent;
    border-radius: 0px 4px 4px 0;
    &:hover {
      border-color: #ddd;
      border-left-color: transparent;
    }
    &.isactive {
      border-color: $--color-primary;
    }
  }
  ::v-deep .handle-select {
    margin-left: 10px;
    &.time {
      width: 120px;
    }
    &.custom {
       .el-input__inner {
        border-radius: 4px 0 0 4px;
      }
    }
  }
  .ads-list {
    padding: 20px;
    .btn-group {
      padding-bottom: 20px;

      .handle-select {
        margin-left: 10px;
      }
      .create-btn {
        margin-right: 10px;
      }
      .type-select {
        margin-left: 0;
        margin-right: 10px;
      }
      .search-type {
        width: 90px;
        ::v-deep .el-input__inner {
          border-right: 0;
        }
      }
      .search-value {
        width: 180px;
      }
      .arrow-down {
        width: 8px;
        height: 5px;
        margin-left: 7px;
      }

      .line {
        width: 1px;
        height: 23px;
        background: #ddd;
        margin: 0;
      }

      .dateBox {
        width: 100px;

        ::v-deep .el-icon-circle-close {
          right: 20px;
        }

        ::v-deep .el-icon-date {
          left: 70px;
          top: 0;
        }
      }
    }

    .list-table {
      padding: 20px;
      background: #fff;
      .name {
        height: 40px;
        .quick-view {
          display: none;
          color: $--color-primary;
          cursor: pointer;
        }
      }
      ::v-deep .el-table__row:hover {
        .quick-view {
          display: block;
        }
      }

      .table-top-border {
        .tab-tit {
          font-size: 14px;
          font-weight: 400;
          color: #666666;

          .is-recommend {
            display: inline-block;
            margin-right: 10px;

            border: 1px solid #dfdfdf;
            border-radius: 3px;
            width: 18px;
            height: 18px;

            font-size: 12px;
            line-height: 16px;
            text-align: center;
            vertical-align: 1px;
            color: #f56c6c;
          }

          .normal,
          .expire {
            display: inline-block;
            margin-left: 5px;
            padding: 0 2px;

            height: 18px;
            font-size: 12px;
            line-height: 17px;
            vertical-align: 1px;
          }

          .normal {
            border: 1px solid #24bd61;
            color: #24bd61;
          }

          .expire {
            border: 1px solid #ac0808;
            color: #ac0808;
          }
        }

        /* 已发布样式 */
        .cell {
          .table-icon {
            @include flex(row, center);
            justify-content: center;
            .svg {
              margin-right: 7px;
            }
          }
        }

        .opertion-box {
          .opertion {
            .recommend-icon {
              margin-left: 5px;
            }
          }
          ::v-deep .el-dropdown {
            span {
              cursor: pointer;
              margin-left: 10px;
              color: $--color-primary;
            }
          }
        }
      }
      ::v-deep .el-dropdown {
        span {
          cursor: pointer;
          margin-left: 10px;
          color: $--color-primary;
        }
      }
      .closed-course {
        background: #f5f5f5;
        border: 1px solid #e6e6e6;
        color: #999999;
      }
      .published-course {
        color: #74c55c;
        background: #f0f9eb;
        border: 1px solid #d5eec8;
      }
      .draft-course {
        background: #ecf5ff;
        color: #409eff;
        //background: #f0f9eb;
        border: 1px solid #c6e2ff;
      }
      .el-pagination {
        padding: 15px 10px;
      }
    }
  }

  .recommend {
    .el-date-editor {
      width: 100%;
    }

    .dialog-footer {
      text-align: right;
    }

    .dialog-tips {
      display: flex;
      flex-direction: row;
      align-items: center;

      font-size: 14px;
      color: #606266;

      .dialog-img {
        margin-right: 10px;
        width: 20px;
        height: 20px;
      }
    }
  }
  ::v-deep .givenDialog {
    .el-input,
    .el-textarea {
      width: 380px;
    }
  }
  ::v-deep .result-ads {
    .drawer-title {
      font-size: 20px;
      color: #333;
    }
    .el-drawer__body {
      padding: 20px 0;
    }
    .el-drawer__header {
      margin-bottom: 0 !important;
      padding-bottom: 0 !important;
    }
  }
}
::v-deep .el-drawer {
  width: 700px !important;
  .basic-item {
    margin-bottom: 5px;

    .basic-item-title {
      margin-bottom: 20px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
    }

    .basic-title-edit {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .basic-edit {
        font-size: 14px;
        font-weight: 400;
        color: $--color-primary;
        cursor: pointer;
      }
    }

    .basic-item-main {
      display: flex;
      .basic-head-item {
        img {
          height: 100px;
          width: auto;
        }
      }
      .main-item {
        width: 50%;

        .el-select,
        .el-input {
          width: 330px;
        }

        .work-card {
          .work-card-item {
            margin-bottom: 15px;
            line-height: 0;

            .work-card-img {
              width: 143px;
              height: 148px;
            }
          }

          .work-card-print {
            margin-bottom: 0;
          }
        }

        .encrypt-number {
          display: flex;

          span {
            display: inline-block;
            width: 115px;
          }

          .show-svg {
            margin-left: 8px;

            .svg-icon {
              margin-top: -2px;
              cursor: pointer;
            }
          }
        }

        .phone-number {
          span {
            width: 75px;
          }
        }

        .job-num-box {
          display: flex;
          font-size: 12px;
          font-weight: 400;
          color: #000;
          vertical-align: middle;

          p {
            margin: 0;
          }

          .job-num-btn {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: $--color-primary;
          }
        }

        .account-lock {
          display: inline-block;
          margin-right: 5px;
        }
      }

      .basic-item-right {
        padding-left: 50px;
      }

      .el-form-item {
        height: 30px;
        margin-bottom: 14px;
      }
    }

    .el-table {
      margin-bottom: 25px;

      .table-empty {
        color: $--color-primary;
        cursor: pointer;
      }
      .grade-box {
        @include flex(row, baseline);
        .grade-main {
          margin-left: 9px;
          border: 1px solid $--color-primary;
          padding: 0 5px;

          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          color: $--color-primary;
        }
      }
    }
  }

  .margin-bottom {
    margin-bottom: 0;
  }
  .lockout-box {
    display: flex;
    align-items: center;

    .svg-icon {
      margin-right: 5px;
    }
  }

  .is-lockout {
    color: #f44242;
  }

  .not-lockout {
    color: #0abf5b;
  }
}
.tree-width {
  width: 200px;
}
</style>
